import { Spinner } from "@/components/ui/spinner";
import { CheckCircle2, XCircle } from "lucide-react";
import * as React from "react";
import { useSearchParams, Link } from "react-router-dom";

export default function VerifyEmailPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const callbackURL = searchParams.get("callbackURL") || "/auth/login";

  const [status, setStatus] = React.useState<"verifying" | "success" | "error">(
    "verifying"
  );

  React.useEffect(() => {
    if (!token) {
      setStatus("error");
      return;
    }

    // Navigate to the actual Better Auth verification endpoint.
    // The server validates the token and redirects to callbackURL.
    const verifyUrl = `/api/auth/verify-email?token=${encodeURIComponent(
      token
    )}&callbackURL=${encodeURIComponent(callbackURL)}`;
    window.location.href = verifyUrl;
  }, [token, callbackURL]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4">
      <div className="w-full max-w-sm text-center space-y-6">
        {/* Logo */}
        <div className="flex justify-center">
          <div className="grid size-14 place-items-center rounded-full bg-primary">
            <span className="text-primary-foreground text-2xl font-bold">
              S
            </span>
          </div>
        </div>
        <p className="text-sm tracking-[0.2em] uppercase text-muted-foreground font-medium">
          ShipPeek TMS
        </p>

        {status === "verifying" && (
          <>
            <div className="flex justify-center">
              <Spinner size="lg" />
            </div>
            <div className="space-y-1">
              <h1 className="text-xl font-semibold">Verifying your email</h1>
              <p className="text-muted-foreground text-sm">
                Please wait while we confirm your email address...
              </p>
            </div>
          </>
        )}

        {status === "error" && (
          <>
            <div className="flex justify-center">
              <XCircle className="size-12 text-destructive" />
            </div>
            <div className="space-y-1">
              <h1 className="text-xl font-semibold text-destructive">
                Invalid link
              </h1>
              <p className="text-muted-foreground text-sm">
                The verification link is missing or has expired.
              </p>
            </div>
            <Link
              to="/auth/login"
              className="inline-block text-sm text-primary hover:underline font-medium"
            >
              Go to sign in
            </Link>
          </>
        )}

        {status === "success" && (
          <>
            <div className="flex justify-center">
              <CheckCircle2 className="size-12 text-emerald-600" />
            </div>
            <div className="space-y-1">
              <h1 className="text-xl font-semibold text-emerald-700">
                Email verified!
              </h1>
              <p className="text-muted-foreground text-sm">
                Redirecting you to sign in...
              </p>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
